<!--
@Description: 销售趋势
@Author: 吳廣帥
@Date:2022/1/5 - 13:40
@Name:lineChart
@Version:v1.0
-->
<style scoped lang="less">
/** 最外层div盒子*/
.trend-box {
  margin-top: .22rem;
  padding: .24rem;
}
.chart{
  margin-top: .24rem;
  width: 7rem;
  height: 3.5rem;
}
.blur-img{
  width: 100vw;
  height:5rem;
}
</style>
<template>
  <!--  组件最外层盒子-->
  <div class="trend-box" v-if="isVip">
    <ButtonGroup :button-group="buttonGroup" label="销售趋势" v-model="chartType"/>
    <div v-show="showChart" ref="chart" class="chart"/>
    <none-data :height="3.5" v-show="!showChart" class="chart" propsText="该主播在所选时间范围内没有卖货"/>
  </div>
  <Blur-image v-else vipText="升级会员，即可查看" class="blur-img" src="https://s6.bihukankan.com/img/1641377514销售趋势.png"/>
</template>
<script>
import ButtonGroup from './buttonGroup'
import moment from "moment";
import {dateLongDuration} from "@/plugins/helper";
export default {
  /** 组件区 **/
  components: { ButtonGroup },
  /** 方法区 **/
  methods: {
    formatY(val) {
      if (isNaN(val)) {return val;}
      if (val >= 100000000) {
        return (val / 100000000).toFixed(1) + '亿';
      } else if (val >= 10000) {
        return val / 10000 + '万';
      } else {
        return val;
      }
    },
    drawChart(){
      if(!this.showChart || !this.isVip) return
      echarts.init(this.$refs.chart).setOption({
        tooltip: {
          trigger: 'axis',
          formatter: item => {
            const params = item[0]
            const date = `<div>日期 <span style="float: right">${params.name}</span></div>`
            switch(this.chartType){
              case 'sales': {
                const sales = this.$retainWan(params.value)
                return(`${date}${ sales ? `<div>当日销售额<span style="margin-left: .24rem">${sales}</span></div>` : '当日未卖货'}`)
              }
              case 'salesVolume': {
                const sales = this.$retainWan(params.value)
                return(`${date}${ sales ? `<div>当日总销量<span style="margin-left: .24rem">${sales}</span></div>` : '当日未卖货'}`)
              }
              case 'commodityAmount': {
                const sales = this.$retainWan(params.value)
                return(`${date}${ sales ? `<div>当日上架商品数<span style="margin-left: .24rem">${sales}</span></div>` : '当日未卖货'}`)
              }
              case 'ASPT': {
                const sales = this.$retainWan(params.value)
                return(`${date}${ sales ? `<div>当日客单价<span style="margin-left: .24rem">${sales}</span></div>` : '当日未卖货'}`)
              }
            }
          }
        },
        grid: {
          left: this.leftValue[this.chartType],
          top: 10,
          bottom: 20,
          right:25,
        },
        xAxis: {
          type:'category',
          data: this.chartData.x,
          axisLabel: { textStyle: { color: '#848f9c' } },
          axisLine: { lineStyle: { color: '#848f9c' } },
          axisTick: { color: '#848f9c' },
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: val =>  this.formatY(val) ,
            color: '#848F9C'
          },
          // interval: this.chartType === 'duration'? 7200 :  1
        },
        series: {
          // smooth: true,
          data: this.chartData.y,
          type: 'line',
          itemStyle: {
            color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
              { offset: 0, color: '#2a89f4' },
              { offset: 1, color: '#54befa' }
            ])
          }
        }
      })
    }
  },
  watch: {
    chartData:{
      immediate:true,
      deep:true,
      handler(){
        this.drawChart()
      }
    },

  },
  /** 数据区 **/
  props: {
    propData:{ type:Object,default:() => ({}) }
  },
  computed: {
    showChart: (_this = this) => _this.chartData.x.length && _this.chartData.y.length && !!_this.chartData.y.reduce( (total,ele) => total += ele || 0,0),
    isVip: (_this = this) => _this.$store.state.userLevel && _this.$store.state.userLevel <= 96,
    chartData: (_this = this) => ({
      x:_this.$props.propData.x ?  _this.$props.propData.x.map( ele => moment(ele).format('MM-DD') ) : [],
      y:_this.$props.propData.y ? _this.$props.propData.y.map( ele => ele[_this.chartType] ? ele[_this.chartType] : 0) : []
    })
  },
  data() {
    return {
      buttonGroup:[{ label:'销售额', key:'sales' }, { label:'销量', key:'salesVolume'},{ label:'商品数', key:'commodityAmount'} ,{ label:'客单价', key:'ASPT'}],
      chartType:'sales',
      leftValue:{
        sales:55,
        salesVolume:35,
        commodityAmount: 35,
        ASPT: 25
      }
    }
  },
}
</script>








